import { useLocation } from "react-router-dom";
import { FiArrowRight, FiMenu } from "react-icons/fi";
import "../styles/Header.css";

const REGISTER_URL = "https://etikaf.com/daftar";

const productLinks = [
  { label: "Cara guna", href: "#cara" },
  { label: "Pakej", href: "#pakej" },
  { label: "Demo", href: "#demo" },
  { label: "Harga", href: "#harga" },
  { label: "FAQ", href: "#faq" },
];

const Header = () => {
  const location = useLocation();
  const isProductPage = location.pathname.toLowerCase() === "/my";

  const closeMobileMenu = (event) => {
    event.currentTarget.closest("details")?.removeAttribute("open");
  };

  return (
    <header className={`app-header ${isProductPage ? "product-header" : "home-header"}`}>
      <div className="content-header">
        <a className="header-logo-link" href="/" aria-label="Kembali ke laman utama Etikaf">
          <img
            src="/assets/etikaf-arab.svg"
            className="App-logo"
            alt="Etikaf"
          />
        </a>

        {isProductPage ? (
          <>
            <nav className="product-header-nav" aria-label="Navigasi Untuk Masjid">
              {productLinks.map((link) => (
                <a key={link.href} href={link.href}>{link.label}</a>
              ))}
              <a className="product-header-cta" href={REGISTER_URL}>
                Daftar <FiArrowRight />
              </a>
            </nav>

            <details className="product-mobile-menu">
              <summary><FiMenu /> Menu</summary>
              <div className="product-mobile-panel">
                {productLinks.map((link) => (
                  <a key={link.href} href={link.href} onClick={closeMobileMenu}>{link.label}</a>
                ))}
                <a className="product-mobile-cta" href={REGISTER_URL}>
                  Daftar Etikaf <FiArrowRight />
                </a>
              </div>
            </details>
          </>
        ) : (
          <nav className="home-header-nav" aria-label="Navigasi utama">
            <a className="home-masjid-link" href="/my">
              Untuk Masjid
            </a>
            <button onClick={() => { window.location.href = "https://admin.etikaf.com"; }}>
              Log Masuk
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
